import React from 'react';

import { HeaderProps } from './Header.type';

const Header = (props: HeaderProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [top, setTop] = React.useState(true);

  const scrollHandler = React.useCallback(() => {
    window.pageYOffset > 10 ? setTop(false) : setTop(true);
  }, [setTop]);

  React.useEffect(() => {
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [scrollHandler]);

  return (
    <>
      <header className="sticky top-0 z-50 max-w-full bg-white w-full transition duration-300 ease-in-out shadow-md filter">
        <div className="flex items-center justify-between h-15 shadow-md">
          {props.canGoback ? (
            <div className="flex items-center" onClick={props.showModalConfirmation}>
              <div className="mr-2">
                <img src="/images/arrowLeftGreen.svg" className="py-1 pl-2 w-6 h-6" />
              </div>
              <div className="w-full text-primary-green text-regular font-interSemiBold">
                Kembali ke pilih kategori
              </div>
            </div>
          ) : (
            <div className="flex items-center">
              <div className="mr-2">
                <img src="/images/logo.svg" className="w-14 h-14 py-1 pl-2 w-10 h-10" />
              </div>
              <div className="flex flex-col flex-space-5">
                <div className="text-gray-gray700 text-small font-interLight capitalize">
                  Yummy Outlet Stock Management
                </div>
                <div className="text-gray-gray700 text-regular font-interSemiBold capitalize">
                  {props.title}
                </div>
              </div>
            </div>
          )}
        </div>
        {props.children}
      </header>
    </>
  );
};

export default Header;
